import BaseSelectField from './BaseSelectField';

export default BaseSelectField;
